module.exports = __webpack_public_path__ + "img/volume-x.60183b4b.svg";